import http from '../../../Utils/http';

const GetRuns = {
  name: 'signJetSyncRuns',
  state: {
    loading: false,
    error: '',
    data: [],
    totalCount: 0,
  },
  reducers: {
    RunsRequested(state) {
      return { ...state, loading: true, error: '' };
    },
    RunsReceived(state, payload) {
      return {
        ...state,
        loading: false,
        error: '',
        data: Array.isArray(payload?.data?.rows) ? payload.data.rows : [],
        totalCount: payload?.data?.count || 0,
      };
    },
    RunsRequestFailed(state, payload) {
      return { ...state, loading: false, error: payload, data: [], totalCount: 0 };
    },
  },
  effects: (dispatch) => ({
    async requestForRuns({ page, rpp, from, to, status, sorted_by, sort }) {
      try {
        this.RunsRequested();
        const params = new URLSearchParams();
        if (sorted_by) params.append('sorted_by', sorted_by);
        if (sort) params.append('sort', sort);
        if (from) params.append('from', from);
        if (to) params.append('to', to);
        if (status) params.append('status', status);
        params.append('page', String(page));
        params.append('rpp', String(rpp));

        const response = await http.get(`savvy/signjet-sync/runs?${params.toString()}`);
        this.RunsReceived(response.data);
      } catch (err) {
        const message = err?.response?.data?.error || err?.message || 'Unknown error';
        this.RunsRequestFailed(message);
        dispatch({
          type: 'helper/show',
          payload: { type: 'error', data: 'Failed to load sync runs', open: true },
        });
      }
    },
  }),
};

export default GetRuns;
